export default {
  information: {
    title: '2',
    firstName: 'Tobias',
    lastName: 'Rothley',
    academicTitle: '',
    birthDate: '',
    birthPlace: ''
  },
  organizationalData: {
    departmentName: '',
    job: 'Future Marketing Architect',
    companyName: 'Orbis/Contrimo',
    personalNumber: '',
    costCenter: ''
  },
  emails: [
    {
      type: 'Work',
      email: 'tobias.rothley@contrimo.com'
    }
  ],
  addresses: [
    {
      type: 'Work',
      street: 'Konrad-Zuse-Ring',
      number: '23',
      postCode: '68163',
      state: '',
      city: 'MannHeim',
      poBox: '',
      country: '1',
      region: '14'
    }
  ],
  communications: [
    {
      type: 'Work',
      phone: '+49(160)90410226'
    }
  ]
};
